export const rangesOverlap = (left, right) => {
  const leftStart = Number(left?.weight);
  const leftEnd = Number(left?.nextWeight);
  const rightStart = Number(right?.weight);
  const rightEnd = Number(right?.nextWeight);

  if (![leftStart, leftEnd, rightStart, rightEnd].every(Number.isFinite)) {
    return false;
  }

  return leftStart < rightEnd && rightStart < leftEnd;
};

export const getBandValidationError = (candidateBand, existingBands = []) => {
  const weight = Number(candidateBand?.weight);
  const nextWeight = Number(candidateBand?.nextWeight);

  if (!Number.isFinite(weight) || !Number.isFinite(nextWeight)) {
    return "Укажите начало и конец диапазона.";
  }

  if (weight >= nextWeight) {
    return "Начало диапазона должно быть меньше конца.";
  }

  if (existingBands.some((band) => rangesOverlap(candidateBand, band))) {
    return "Диапазон пересекается с существующими весовыми брейками.";
  }

  return "";
};
